import {
  camelCase,
  isDate as lowDate,
  tail,
  head,
  isArray
} from 'lodash'
import {setDefault, isDefaultOrStompable} from '../defaults/defaults'
import {Log} from '../log/logger'

export function similarTo(key: string, path: string): boolean {
  return path.split('.').filter(p =>
    camelCase(key) === camelCase(p)
  ).length > 0
}

export function checkDate(value: any, coerceNumbersToDates: boolean = false): Date {
  return lowDate(value) || [].concat(
    (!coerceNumbersToDates &&
      (!value ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) ?
      undefined :
      new Date(value)
  ).map(
    possibleDate =>
      (possibleDate && !isNaN(possibleDate.getTime())) ?
        possibleDate : undefined
  ).shift()
}

export function isDate(value: any, coerceNumbersToDate: boolean = false): boolean {
  return !!checkDate(value, coerceNumbersToDate)
}

function getJSType(val: any): string {
  if (isArray(val)) return 'array'
  if (isDate(val)) return 'date'
  return typeof val
}

export function setOnPath<T>(
  parent: object,
  path: string,
  value: T,
  stomp: boolean = false,
  current: object = parent
): object {
  const val = fLast<string>(path.split('.'))

  const setFirst = () => {
    const firstVal = current[val.first]
    const firstType = getJSType(value)
    const stompValue = isDefaultOrStompable(current, val.first) || stomp
    if (stompValue) {
      const name = current.constructor.name || 'Non-class object'
      Log.warn(`Overriding value found at property '${val.first}' ` +
        `on ${name}.\nCurrent: '${current[val.first]}'` +
        `\nNew: '${value}'`)
    }
    switch (firstType) {
      case 'array':
        current[val.first] = (stompValue) ? value : firstVal.concat(value)
        break
      case 'string':
      case 'boolean':
      case 'number':
      case 'date':
      case 'object':
        current[val.first] = (stompValue) ? value : firstVal
        break
    }
  }

  if (val.last.length) {
    if (
      typeof current[val.first] !== 'boolean' &&
      !current[val.first]
    ) {
      current[val.first] = {}
      setDefault(current, val.first)
    }
    if (typeof current[val.first] === 'object') {
      setOnPath(
        parent,
        val.last.join('.'),
        value,
        stomp,
        current[val.first])
    }
  } else {
      setFirst()
  }
  return parent
}

export function getValueFromString(obj: any, path: string): any {
  const val = fLast<string>(path.split('.'))
  return (val.last.length) ?
    getValueFromString(obj[val.first], val.last.join('.')) :
    obj[val.first]
}

export type FLast<T> = {
  first: T,
  last: T[]
}

export function fLast<T>(arr: T[]): FLast<T> {
  return {
    first: head(arr),
    last: tail(arr)
  }
}
